import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';

@Component({
  selector: 'app-refundlist',
  templateUrl: './refundlist.component.html',
  styleUrls: ['./refundlist.component.css']
})
export class RefundlistComponent implements OnInit {

  title = "Refund List";
  constructor() { }

  ngOnInit() {
  }

  payment(){
    swal({
      //title: '<i>HTML</i> <u>example</u>',
      //type: 'info',
      html:
        '<h3>Refunded</h3>'+
        '<textarea placeholder="Note" class="form-control" style="height:100px;margin-top:10px;"></textarea><br><br>' ,
        
        // '<label>DD Copy</label><input style="width:70%;display:inline-block;margin-left:20px;"  type="file" class="form-control">' ,
        
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        'Save',    
      cancelButtonText:
      'Cancel',
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/refundlist/refundlist.component.ts